var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000074443740648224601370000018110516528991944586_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m511.5 295.7c1.2 4.9.1 10-3 14-63.3 82.4-181.4 98-263.8 34.7-13-10-24.7-21.7-34.7-34.7-3.1-4-4.2-9.1-3-14 18.7-79 79.8-136.9 152.3-136.9s133.5 57.9 152.2 136.9z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.3,
    cy: 79.3,
    fill: "#f7d1b2",
    r: 79.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305 349.2c1.2 4.9.1 10-3 14-63.3 82.4-181.4 98-263.8 34.7-13-10-24.7-21.6-34.7-34.7-3.1-4-4.2-9.1-3-14 18.7-79 79.8-136.9 152.2-136.9s133.5 57.9 152.3 136.9z",
    fill: "#1da6c6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.7,
    cy: 132.9,
    fill: "#f7d1b2",
    r: 79.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.4,
    cy: 386,
    fill: "#58c87e",
    r: 126
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.5 442.9c-2.1 0-4.2-.8-5.7-2.4l-39.8-39.8c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l34.1 34.1 92-92c3.2-3 8.3-2.9 11.3.3 2.9 3.1 2.9 7.9 0 11l-97.7 97.7c-1.4 1.5-3.4 2.3-5.5 2.4z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgents);
export default __webpack_public_path__ + "static/media/agents.6c0c1b5ef10d764614f15411883d4d7f.svg";
export { ForwardRef as ReactComponent };